<template>
  <div class="wrapper">
    <header-nav :index_num="index_num"></header-nav>
    <div id="box">
      <router-link :to="{name:'project'}">
        <div>
          <img :src="imgUrl.left">
          征集类项目
        </div>
      </router-link>
      <router-link :to="{name:'project_solicitation'}">
        <div>
          <img :src="imgUrl.right">
          非征集类项目
        </div>
      </router-link>
    </div>
    <footer-nav class="footer"></footer-nav>
  </div>
</template>
<script>
  import HeaderNav from "../components/HeaderNav";
  import FooterNav from "../components/FooterNav";
  export default {
    components: {
      HeaderNav,
      FooterNav
    },
    props: {},
    data() {
      return {
        imgUrl: {
          left: require("../../static/img/transition_left.png"),
          right: require("../../static/img/transition_right.png")
        },
        animate: false,
        tips: "",
        itemss: [],
        index_num: 2,
        pageSize: 1,
        currentPage: 1,
        totalCount: 1,
        text: ["全部"],
        sub: 0,
        bgData: [],
        bgValue: [],
        type_value: "项目类型",
        status_value: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0" + "项目状态",
        area_value: "落地区域",
        value_date: "",
        start_time: "",
        end_time: "",
        cd: Number,
        selinfo: {},
        typeval: '',
        areaval: '',
        statusval: "",
        buttstatus: ""
      };
    },
    methods: {
      type(e) {
        this.prolist(this.value_date[0], this.value_date[1], this.typeval, this.statusval, this.areaval);
      },
      prolist(time0, time1, type, area, status, currentPage) {
        time0 = time0 ? time0 : ""
        time1 = time1 ? time1 : ""
        type = type ? type : ""
        area = area ? area : ""
        status = status ? status : ""
        this.$http({
            method: "get",
            url: "v1/project/list",
            params: {
              start_time: this.value_date ? this.value_date[0] : '',
              end_time: this.value_date ? this.value_date[1] : '',
              type: this.typeval,
              area: this.areaval,
              status: this.statusval,
              page: currentPage ? currentPage : 0,
              num: 6
            }
          })

          .catch(err => {
            // // console.log(error);(err);
          });
      },
      /** 获取项目列表 */
      getDataTwo(
        start_time = this.start_time,
        end_time = this.end_time,
        type = this.type_value,
        status = this.status_value,
        area = this.area_value
      ) {
        if (type === "项目类型") {
          this.type_value = "";
          type = "";
        }
        if (status === "项目状态") {
          this.status_value = "";
          status = "";
        }
        if (area === "落地区域") {
          this.area_value = "";
          area = "";
        }

        let _this = this;
        if (this.type_value === "") {
          this.type_value = "项目类型";
        }
        if (this.status_value === "") {
          this.status_value = "项目状态";
        }
        if (this.area_value === "") {
          this.area_value = "落地区域";
        }
      },
      /** 获取下拉框数据 */
      setButton() {
        this.$jump('application');
        let _this = this;
        this.$http({
          method: "get",
          url: "v1/project/setpro?id=" + sessionStorage.getItem("party_id"),
          data: {}
        }).then(res => {
          let buttonStatus = res.data.data.code;
          let buttonMsg = res.data.data.msg;
          if (this.buttstatus == 0 || this.buttstatus == 3) {
            this.$alert("您当前社会组织状态为：活动异常，请与主管单位联系审核！", "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          } else if (this.buttstatus == 4) {
            this.$alert("项目申报暂未开始！", "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          } else if (buttonStatus == 200 && this.buttstatus == 1) {
            this.$jump('application');
          } else {
            this.$alert(buttonMsg, "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
            return false;
          }
        }).catch(err => {});
      },
      //非征集项目类型申报入口
      solicitation_entrance() {
        this.$jump('project_solicitation');
      },
      btn(index) {
        let s = this.sub;
        s = index;
        this.sub = s;
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getPackData();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        // this.getDataTwo();
        this.prolist("", "", "", "", "", val)
        this.getPackData();
      },
      getPackData() {},
      scroll() {
        var _this = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
        if (_this.itemss.length == 1) {

        } else {
          let con1 = this.$refs.con1;
          con1.style.marginTop = '-40px';
          this.animate = !this.animate;

          setTimeout(function () {
            _this.itemss.push(_this.itemss[0]);
            _this.itemss.shift();
            con1.style.marginTop = '0px';
            _this.animate = !_this.animate; // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
          }, 500)
        }

      }
    },
    created() {
      this.prolist();
      setInterval(this.scroll, 3000)
    },
    mounted() {},
    computed: {

    },
    beforeUpdate() {
      localStorage.setItem("page", this.currentPage);
    },
    beforeDestroy() {
      localStorage.setItem("page", 1);
    },
    destroyed() {
      localStorage.removeItem("page");
    }
  };

</script>
<style lang="scss" scoped>
  .wrapper /deep/ .el-input__inner {
    width: 200px;
  }

  .wrapper /deep/.area .el-input__inner {
    text-align: center;
  }

  .block-ky {
    display: flex;
    font-size: 14px;
    color: #666666;

    .status1 {
      width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .wrapper {
    min-width: 1280px;
    box-sizing: border-box;

    .footer {
      margin-top: 80px;
    }

    #box {
      margin: 142px auto 277px;
      width: 1200px;
      box-sizing: border-box;
      display: flex;
      align-content: center;
      justify-content: space-around;

      div {
        min-width: 280px;
        height: 175px;
        background: linear-gradient(69deg, #E60012, #F42B47, #CC263F);
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-size: 18px;
        font-weight: 500;
        cursor: pointer;

        img {
          width: 56px;
          height: 50px;
          margin-bottom: 30px;
        }
      }
    }
  }

  .xmmz {
    width: 125px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis
  }

  .anim {
    transition: all 1s;
  }

  #con1 li {
    list-style: none;
    line-height: 30px;
    height: 30px;
  }

</style>
